<template lang="pug">
.product_type(v-show="pageShow")
  banner(:banner="accessory")
  .pt-2.pb-5.bg-light
    .container
      .title-box.mb-4(ref="productTableBlock")
        h2.d-inline.mr-2 Product Table
        p.d-inline.mb-0.text-primary
          | ( Legacy products are not included. If you need supports,&#32;
          a(@click="toContactUs", style="cursor: pointer") please contact us directly
          |
          | )
      .tab-bar.product
        b-tabs(v-model="currentTableTabIndex")
          ul#myTab.nav.nav-tabs(role="tablist")
            li.nav-item(
              v-for="(productTable, index) in accessory.product_tables"
            )
              b-tab(
                :title="productTable.name",
                :key="index",
                @click="tableTabClick(index)"
              )
        b-dropdown.bg-white(
          size="sm",
          text="Show/Hide Columns",
          variant="outline-secondary",
          v-show="false"
        )
          b-dropdown-form
            b-form-checkbox(
              v-model="checkboxSelectedList",
              v-for="(checkbox, index) in tableHeadList",
              :key="index",
              :value="checkbox",
              size="sm"
            ) {{ checkbox.name }}
      #myTabContent2.tab-content.application-tab
        #home1.tab-pane.fade.show.active(
          role="tabpanel",
          aria-labelledby="home-tab"
        )
          .row.mr-0.ml-0
            .col-12.pr-0.pl-0
              .table-responsive
                table.table.table-bordered.table-sm
                  thead
                    tr
                      sticky-column.bdr2(:offset="0") Product
                      th(
                        scope="col",
                        v-for="(head, index) in tableHeadList",
                        :key="index",
                        v-if="isColShow(index)"
                      ) {{ head.name }}
                  tbody
                    tr(
                      v-for="(row, index) in currentAccessoryList",
                      :key="index"
                    )
                      sticky-column.bdr2.fixed_column(:offset="0")
                        a(
                          style="text-decoration: underline; cursor: pointer",
                          @click="showProductDialog(row)",
                          v-b-modal.icModal="",
                          data-toggle="modal",
                          data-target="#icModal"
                        )
                          strong {{ row.name }}
                      td(
                        v-if="isColShow(index)",
                        v-for="(object, index) in tableHeadList",
                        :key="index"
                      ) {{ row.table_data[object.id] }}
          b-pagination.pagination-sm.justify-content-end.mb-5(
            v-if="currentAccessoryList.length > 0",
            v-model="currentPage",
            :total-rows="pages",
            :per-page="perPage",
            first-number,
            last-number,
            prev-text="Previous",
            next-text="Next"
          )
  .py-5.bg-white
    .container
      h2.mb-4 Application Cases
      .row.application-list
        .col-lg-3.col-md-6(
          v-for="(application, index) in accessory.application_cases_brief",
          :key="index"
        )
          .list
            .img(
              v-if="application.photo",
              :style="{ backgroundImage: 'url(' + application.photo.image + ')' }"
            )
              .d-flex.justify-content-center.align-items-center
                h3 {{ application.title }}
            .text
              a(
                style="cursor: pointer",
                @click="applicationClick(application)"
              )
                h5 {{ application.subtitle }}
              p {{ application.challenge_desc }}
  banner-slider(v-if="pageShow", :bannerList="bannerList")
  float-actions
  float-top
  .PCAP-IC-selector.d-block.d-sm-none
    a.shadow-sm(
      v-b-modal.dialog="",
      @click="$bvModal.show('selectorModal')",
      data-toggle="modal",
      data-target="#selectorModal"
    )
      font-awesome-icon.i_mr_1(:icon="['fas', 'search']") 
      | PCAP IC selector
  custom-footer
  dialog-product-i-c(v-if="selectedProduct", :product="selectedProduct")
  dialog-product-module(v-if="selectedProduct", :product="selectedProduct")
</template>

<script>
import Footer from "@/components/home/Footer";
import FloatTop from "@/components/common/FloatTop";
import FloatActions from "@/components/common/FloatActions";
import Banner from "@/components/product_type/Banner";
import ProductSeries from "@/components/product_type/ProductSeries";
import DialogProductIC from "@/components/application/DialogProductIC";
import DialogProductModule from "@/components/application/DialogProductModule";
import BannerSlider from "@/components/ic_selector/Banner";
import { getBannerList } from "@/api/company";
import { getAccessoryByID } from "@/api/product";
import StickyColumn from "@/components/common/StickyColumn";

export default {
  name: "Accessory",
  components: {
    "custom-footer": Footer,
    "float-top": FloatTop,
    "float-actions": FloatActions,
    Banner,
    BannerSlider,
    DialogProductIC,
    DialogProductModule,
    ProductSeries,
    StickyColumn,
  },
  data() {
    return {
      pageShow: false,
      bannerList: [],
      accessory: {},

      tableHeadList: [],

      checkboxSelectedList: [],
      currentTableTabIndex: 0,

      accessoryList: [],
      pages: 1,
      perPage: 5,
      currentPage: 1,
      currentAccessoryList: [],

      swiperOption: {
        notNextTick: true,
        initialSlide: 1,
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 30,
        loop: false,
        direction: "horizontal",
        grabCursor: false,
        setWrapperSize: true,
        autoHeight: false,
        mousewheelControl: true,
        observeParents: true,
        debugger: true,
        paginationClickable: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        breakpoints: {
          999: {
            // >=999
            slidesPerView: 6,
            slidesPerGroup: 6,
            spaceBetween: 30,
          },
          481: {
            // >=481
            slidesPerView: 4,
            slidesPerGroup: 4,
            spaceBetween: 30,
          },
        },
      },
      selectedProduct: null,
    };
  },
  watch: {
    currentPage() {
      this.getCurrentList();
    },
    "$route.params.link_id"() {
      this.getAccessoryByID();
    },
    "$route.params.tab_id"() {
      this.currentPage = 1;
      this.currentAccessoryList = [];
      this.checkTab();
    },
    "$store.state.user.language"() {
      this.initialLanguage();
    },
  },
  created() {
    this.initialLanguage();
  },
  methods: {
    initialLanguage() {
      this.getBannerList();
      this.getAccessoryByID();
    },
    getAccessoryByID() {
      let temp = {
        lang: this.$store.state.user.language,
      };
      getAccessoryByID(temp, this.$route.params.link_id).then((response) => {
        this.accessory = response.data;
        this.$nextTick(() => {
          this.pageShow = true;
          this.checkTab();
        });
      });
    },
    getBannerList() {
      let temp = {
        lang: this.$store.state.user.language,
      };
      getBannerList(temp).then((response) => {
        this.bannerList = response.data;
      });
    },
    tableTabClick(index) {
      if (
        this.accessory.product_tables &&
        this.accessory.product_tables[index]
      ) {
        this.$router.push({
          name: "Accessory",
          params: {
            link_id: this.$route.params.link_id,
            tab_id: this.accessory.product_tables[index].id,
          },
        });
      }
    },
    checkTab() {
      for (let index in this.accessory.product_tables) {
        let temp = this.accessory.product_tables[index];

        if (this.$route.params.tab_id == temp.id) {
          this.currentTableTabIndex = Number(index);
          break;
        } else {
          this.currentTableTabIndex = 0;
        }
      }
      this.getCurrentData();
    },
    getCurrentData() {
      if (
        this.accessory.product_tables &&
        this.accessory.product_tables.length > 0 &&
        this.currentTableTabIndex != -1
      ) {
        this.tableHeadList = [];
        this.checkboxSelectedList = [];
        for (let index in this.accessory.product_tables[
          this.currentTableTabIndex
        ].columns) {
          let temp =
            this.accessory.product_tables[this.currentTableTabIndex].columns[
              index
            ];
          this.tableHeadList.push(temp);
          if (temp.is_show_default) {
            this.checkboxSelectedList.push(temp);
          }
        }

        this.accessoryList =
          this.accessory.product_tables[this.currentTableTabIndex].accessories;
      }

      this.getCurrentList();
    },
    getCurrentList() {
      this.currentAccessoryList = [];
      let number = this.perPage * this.currentPage;
      this.pages = this.accessoryList.length;
      this.currentAccessoryList = this.accessoryList.slice(
        number - this.perPage,
        number
      );

      this.slideToProductTable();
    },
    showProductDialog(product) {
      this.selectedProduct = product;

      this.$bvModal.show("icModal");
    },
    isColShow(index) {
      if (this.checkboxSelectedList.indexOf(this.tableHeadList[index]) != -1) {
        return true;
      }
    },
    applicationClick(application) {
      this.$router.push({
        name: "Application",
        params: {
          tab_id: application.application_id,
          sub_tab_id: application.id,
        },
      });
    },
    slideToProductTable() {
      this.$nextTick(() => {
        if (this.$route.params.need_slide == 1) {
          let topLength = 0;

          topLength = this.$refs.productTableBlock.offsetTop - 100;

          window.scrollTo({
            top: topLength,
            behavior: "smooth",
          });
        }
      });
    },
    toContactUs() {
      this.$router.push({ name: "ContactUs" });
    },
  },
  computed: {
    swiper() {
      return this.$refs.productSwiper.$swiper;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/common/nav_tab";
@import "@/assets/style/common/sticky_nav";
@import "@/assets/style/common/pagination";
@import "@/assets/style/common/table";
@import "@/assets/style/product_type/product_type";

.fixed_column {
  width: 180px;
  min-width: 180px;
  word-break: break-all;
}

@media (max-width: 767px) {
  .fixed_column {
    width: 130px;
    min-width: 130px;
  }
}
</style>
